<app-navbar title="Historia">
	<a routerLink="../" class="btn btn-danger"> <i class="fas fa-chevron-left"></i> Powrót </a>
</app-navbar>

<app-history type="drivers" [id]="id"></app-history>
